import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { axiosInstance } from '../../../utils/axios';

export const fetchChat = createAsyncThunk('chat/fetchChat', async (_, { rejectWithValue }) => {
  try {
    const response = await axiosInstance.get(`api/v1/collections/queryset/?name=&phone=&proscai_id=&store=&manager=`);
    return response.data;
  } catch (error) {
    return rejectWithValue(error.response?.data || 'Error al obtener data');
  }
});

const chatSlice = createSlice({
  name: 'chat',
  initialState: {
    chat: [],
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchChat.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchChat.fulfilled, (state, action) => {
        state.loading = false;
        state.documents = action.payload;
      })
      .addCase(fetchChat.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default chatSlice.reducer;
